/**
 * `@repo/conferencing/components` — the browser half.
 *
 * SPLIT FROM `.` ON PURPOSE. The api-server bundles the port (`.`) and must not
 * pull React in behind it; the browser bundles this and must not pull the
 * server's transport in behind that. One package, two faces, and the split is
 * the export map rather than a convention.
 *
 * `Call.Stage` is absent from the namespace below, and that is the arrangement's
 * one load-bearing rule made structural: the provider renders the stage, a
 * variant never can, and remote audio therefore cannot die on a minimise.
 */
import { CallCompactControls, CallControls, CallExpand, CallMinimise } from "./controls";
import { CallFrame } from "./frame";
import { CallHeader } from "./header";
import { CallWaitingChip, CallWaitingList } from "./waiting";

export type { ActiveCall, CallRole } from "./call-store";
export { callStore, enterCall, expandCall, leaveCall, minimiseCall, useActiveCall } from "./call-store";
export type {
  CallActions,
  CallContextValue,
  CallGeometry,
  CallStatus,
  CallTile,
  WaitingEntry,
} from "./context";
export { useCall } from "./context";
export type { CallFrameProps } from "./frame";
export type { CallHeaderProps } from "./header";
export type { ConferencingProviderProps } from "./provider";
export { ConferencingProvider, mediaReadiness, useMediaReadiness } from "./provider";
export { isRingingOut } from "./ringing-out";

/** The chrome. Every part reads `useCall()`; none takes geometry. */
export const Call = {
  Frame: CallFrame,
  Header: CallHeader,
  Controls: CallControls,
  CompactControls: CallCompactControls,
  Minimise: CallMinimise,
  Expand: CallExpand,
  WaitingList: CallWaitingList,
  WaitingChip: CallWaitingChip,
};

export { configureCallDiagnostics } from "./diagnostics";
